export const PATH_PERMISSION = {
  '/': null,
  '/network-map': 'assets:read',
  '/assets': 'assets:read',

  '/baseline': 'assets:read',

  '/org/members': 'users:read',
  '/settings': 'settings:read',
  '/vulnerabilities': 'assets:read',
  '/agents': 'assets:read',
  '/import': 'assets:create',
  '/threats': 'events:read',
  '/security-alerts': 'events:read',
  '/cases': 'events:read',
  '/response-actions': 'actions:read',
  '/platform/organizations': null,
  '/demo-flow': null,
};

export const PERMISSION_PAGES = {
  'events:read': ['MyCERT Insights', 'Cases'],
  'assets:read': ['Network Map', 'MyAssets', 'Baseline Management', 'Vulnerabilities', 'Agent Registry'],
  'playbooks:view': ['ChatOps Console'],
  'users:read': ['Members & Roles'],
  'settings:read': ['Settings'],
  'events:create': [],
  'events:read': [],
  'events:update': [],
  'events:delete': [],
  'assets:create': [],
  'assets:update': [],
  'assets:delete': [],
  'users:create': [],
  'users:update': [],
  'users:delete': [],
  'users:password_reset': [],
  'roles:read': [],
  'roles:create': [],
  'roles:update': [],
  'roles:delete': [],
  'roles:assign': [],
  'playbooks:approve': [],
  'chatops:view': [],
  'chatops:execute': [],
  'reports:read': [],
  'reports:create': [],
  'reports:update': [],
  'reports:delete': [],
  'orgs:create': [],
  'actions:create': [],
  'actions:read': [],
  'actions:confirm': [],
};

export const APP_PAGES = [
  { path: '/', label: 'Dashboard', actions: [] },
  { path: '/network-map', label: 'Network Map', actions: [] },
  { path: '/assets', label: 'MyAssets', actions: [
    { label: 'View assets',    perm: 'assets:read' },
    { label: 'Add assets',     perm: 'assets:create' },
    { label: 'Edit assets',    perm: 'assets:update' },
    { label: 'Delete assets',  perm: 'assets:delete' },
  ]},
  { path: '/baseline', label: 'Baseline Management', actions: [] },
  { path: '/vulnerabilities', label: 'Vulnerabilities', actions: [] },
  { path: '/agents', label: 'Agent Registry', actions: [] },
  { path: '/threats', label: 'IoC Alerts', actions: [] },
  { path: '/security-alerts', label: 'Security Alerts', actions: [] },

  { path: '/org/members', label: 'Members & Roles', actions: [
    { label: 'View members',     perm: 'users:read' },
    { label: 'Invite members',   perm: 'users:create' },
    { label: 'Edit members',     perm: 'users:update' },
    { label: 'Remove members',   perm: 'users:delete' },
    { label: 'Reset passwords',  perm: 'users:password_reset' },
    { label: 'Manage roles',     perm: 'roles:assign' },
  ]},
  { path: '/settings', label: 'Settings', actions: [
    { label: 'View settings',    perm: 'settings:read' },
    { label: 'Edit settings',    perm: 'settings:update' },
    { label: 'Manage integrations', perm: 'settings:integrations' },
    { label: 'Manage API keys',  perm: 'settings:api_keys' },
  ]},
];

export const PAGE_PERMISSIONS = {};
APP_PAGES.forEach(page => {
  if (page.actions.length) {
    PAGE_PERMISSIONS[page.path] = page.actions.map(a => a.perm);
  }
});
const _fallbackPerms = {
  '/network-map':      ['assets:read'],
  '/baseline':         ['assets:read'],
  '/threats':          ['events:read'],
  '/security-alerts':  ['events:read'],
};
APP_PAGES.forEach(page => {
  if (!PAGE_PERMISSIONS[page.path]) {
    PAGE_PERMISSIONS[page.path] = _fallbackPerms[page.path] || [];
  }
});

export const PERMISSION_PAGES_MAP = {
  'assets:read':           ['/network-map', '/assets', '/baseline', '/vulnerabilities', '/agents'],
  'assets:create':         ['/assets', '/import'],
  'assets:update':         ['/assets'],
  'assets:delete':         ['/assets'],
  'events:read':           ['/threats', '/security-alerts', '/cases'],
  'users:read':            ['/org/members'],
  'users:create':          ['/org/members'],
  'users:update':          ['/org/members'],
  'users:delete':          ['/org/members'],
  'users:password_reset':  ['/org/members'],
  'roles:assign':          ['/org/members'],
  'settings:read':         ['/settings'],
  'settings:update':       ['/settings'],
  'settings:integrations': ['/settings'],
  'settings:api_keys':     ['/settings'],
  'actions:read':          ['/response-actions'],
  'actions:create':        ['/response-actions'],
  'actions:confirm':       ['/response-actions'],
};
